<template>
  <div :style="cssProps">
    <label class="switch">
      <input ref="switch" :value="value" @click="emitValue" :checked="value" :disabled="disabled" type="checkbox" />
      <span class="slider round" :style="cursor"></span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#00995D',
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: Boolean,
      default: false,
      required: true
    },
    number: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      valueData: this.value
    }
  },
  mounted() {
    if (this.disable && this.valueData) {
      this.valueData = false
      this.$emit('input', false)
    }
  },
  methods: {
    emitValue() {
      this.valueData = !this.value
      this.$emit('index', this.number)
      this.$emit('input', this.valueData)
    }
  },
  computed: {
    cssProps() {
      return {
        '--switch-color': this.color
      }
    },
    cursor() {
      return { cursor: this.disabled ? 'not-allowed' : 'pointer' }
    }
  }
}
</script>

<style lang="sass" scoped>
.switch
  position: relative
  display: inline-block
  width: 34px
  height: 19px

input
    opacity: 0
    width: 0
    height: 0

.slider
  position: absolute
  cursor: pointer
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: #ccc
  -webkit-transition: .4s
  transition: .4s

.slider:before
  position: absolute
  content: ""
  height: 13px
  width: 13px
  left: 4px
  bottom: 3px
  background-color: white
  -webkit-transition: .4s
  transition: .4s

.slider.round
  border-radius: 34px

.slider.round:before
  border-radius: 50%

input:checked + .slider
  background-color: var(--switch-color)

input:focus + .slider
  box-shadow: 0 0 1px var(--switch-color)

input:checked + .slider:before
  -webkit-transform: translateX(13px)
  -ms-transform: translateX(13px)
  transform: translateX(13px)
</style>
